module.exports = __webpack_public_path__ + "static/media/defects.a40004a2.svg";